export default __webpack_public_path__ + "static/media/d9.0c5ca7ea.png";